module.exports = __webpack_public_path__ + "img/logo1.f719b907.png";